(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["photo-upload"] && !Shopify.designMode) return;
  try {
    class PhotoUploadBlock extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-photo-upload-input]');
      this.label = this.querySelector('.photo-upload-block__label');
      this.labelText = this.querySelector('.photo-upload-block__label-text');
      this.preview = this.querySelector('[data-photo-preview]');
      this.previewImg = this.querySelector('[data-preview-img]');
      this.removeBtn = this.querySelector('[data-remove-photo]');
      this.errorDiv = this.querySelector('[data-photo-error]');

      this.input?.addEventListener('change', this.handleFileChange.bind(this));
      this.removeBtn?.addEventListener('click', this.handleRemove.bind(this));

      // Validate on form submit attempt
      const formId = this.input?.getAttribute('form');
      if (formId) {
        const form = document.getElementById(formId);
        form?.addEventListener('submit', this.handleFormSubmit.bind(this));
      }
    }

    handleFileChange(e) {
      const file = e.target.files?.[0];
      this.showError('');

      if (!file) return;

      // Validate type
      if (!file.type.startsWith('image/')) {
        this.showError('Please upload an image file (JPEG, PNG, or WebP).');
        this.input.value = '';
        return;
      }

      // Validate size (10MB)
      if (file.size > 10 * 1024 * 1024) {
        this.showError('Image must be under 10MB. Please choose a smaller file.');
        this.input.value = '';
        return;
      }

      // Show preview
      const reader = new FileReader();
      reader.onload = (ev) => {
        this.previewImg.src = ev.target.result;
        this.preview.style.display = 'flex';
        this.label.dataset.hasFile = 'true';
        this.labelText.textContent = file.name.length > 30 ? file.name.substring(0, 28) + '...' : file.name;
      };
      reader.readAsDataURL(file);
    }

    handleRemove() {
      this.input.value = '';
      this.preview.style.display = 'none';
      this.label.dataset.hasFile = 'false';
      this.labelText.textContent = this.labelText.dataset.labelDefault || 'Choose Photo';
      this.previewImg.src = '';
    }

    handleFormSubmit(e) {
      if (!this.input?.files?.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.showError('Please upload your photo before adding to cart.');
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
    }

    showError(msg) {
      if (!this.errorDiv) return;
      this.errorDiv.textContent = msg;
      this.errorDiv.style.display = msg ? 'block' : 'none';
    }
  }

  customElements.define('photo-upload-block-component', PhotoUploadBlock);
  } catch(e) { console.error(e); }
})();

})();
